var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/forbid-prop-types */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */
var React = require("react");
var _ = require("underscore");

var _require = require("aphrodite"),
    StyleSheet = _require.StyleSheet,
    css = _require.css;

var ApiOptions = require("../perseus-api.jsx").Options;
var Changeable = require("../mixins/changeable.jsx");
var GradedGroup = require("./graded-group.jsx").widget;

var _require2 = require("../styles/constants.js"),
    grayLight = _require2.grayLight,
    gray76 = _require2.gray76,
    tableBackgroundAccent = _require2.tableBackgroundAccent,
    kaGreen = _require2.kaGreen,
    phoneMargin = _require2.phoneMargin,
    negativePhoneMargin = _require2.negativePhoneMargin;

var _require3 = require("../gorgon/proptypes.js"),
    linterContextProps = _require3.linterContextProps,
    linterContextDefault = _require3.linterContextDefault;

var Indicators = React.createClass({
    displayName: "Indicators",

    propTypes: {
        currentGroup: React.PropTypes.number.isRequired,
        numGroups: React.PropTypes.number.isRequired,
        onChangeCurrentGroup: React.PropTypes.func.isRequired
    },
    render: function render() {
        var _this = this;

        var items = [];

        var _loop = function _loop(i) {
            items.push(React.createElement("div", {
                key: i,
                className: css(styles.indicator, i === _this.props.currentGroup && styles.selectedIndicator),
                onClick: function onClick() {
                    return _this.props.onChangeCurrentGroup(i);
                }
            }));
        };

        for (var i = 0; i < this.props.numGroups; i++) {
            _loop(i);
        }
        return React.createElement(
            "div",
            { className: css(styles.indicatorContainer) },
            items
        );
    }
});

// TODO(jared): find a better name for this :) and for GradedGroup; the names
// are currently a little confusing.
var GradedGroupSet = React.createClass({
    displayName: "GradedGroupSet",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,
        gradedGroups: React.PropTypes.array,
        trackInteraction: React.PropTypes.func.isRequired,
        linterContext: linterContextProps
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            gradedGroups: [],
            linterContext: linterContextDefault
        };
    },
    getInitialState: function getInitialState() {
        return {
            currentGroup: 0
        };
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        return nextProps !== this.props || nextState !== this.state;
    },
    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    // Mobile API
    getInputPaths: function getInputPaths() {
        return this._childGroup.getInputPaths();
    },
    setInputValue: function setInputValue(path, newValue, cb) {
        return this._childGroup.setInputValue(path, newValue, cb);
    },
    getAcceptableFormatsForInputPath: function getAcceptableFormatsForInputPath(path) {
        return this._childGroup.getAcceptableFormatsForInputPath(path);
    },
    focus: function focus() {
        return this._childGroup.focus();
    },
    focusInputPath: function focusInputPath(path) {
        this._childGroup.focusInputPath(path);
    },
    blurInputPath: function blurInputPath(path) {
        this._childGroup.blurInputPath(path);
    },
    handleNextQuestion: function handleNextQuestion() {
        var currentGroup = this.state.currentGroup;

        var numGroups = this.props.gradedGroups.length;

        if (currentGroup < numGroups - 1) {
            this.setState({ currentGroup: currentGroup + 1 });
        }
    },
    render: function render() {
        var _this2 = this;

        var currentGroup = this.props.gradedGroups[this.state.currentGroup];
        if (!currentGroup) {
            return React.createElement(
                "span",
                null,
                "No current group..."
            );
        }

        var numGroups = this.props.gradedGroups.length;
        var handleNextQuestion = this.state.currentGroup < numGroups - 1 ? this.handleNextQuestion : null;

        return React.createElement(
            "div",
            { className: css(styles.container) },
            React.createElement(
                "div",
                { className: css(styles.top) },
                React.createElement(
                    "div",
                    { className: css(styles.title) },
                    currentGroup.title
                ),
                React.createElement("div", { className: css(styles.spacer) }),
                React.createElement(Indicators, {
                    numGroups: numGroups,
                    currentGroup: this.state.currentGroup,
                    onChangeCurrentGroup: function onChangeCurrentGroup(currentGroup) {
                        return _this2.setState({ currentGroup: currentGroup });
                    }
                })
            ),
            React.createElement(GradedGroup, _extends({
                key: this.state.currentGroup,
                ref: function ref(comp) {
                    return _this2._childGroup = comp;
                }
            }, this.props, currentGroup, {
                inGradedGroupSet: true,
                title: null,
                onNextQuestion: handleNextQuestion,
                linterContext: this.props.linterContext
            }))
        );
    }
});

var traverseChildWidgets = function traverseChildWidgets(props, traverseRenderer) {
    // NOTE(jared): I have no idea how this works
    return {
        groups: props.gradedGroups.map(traverseRenderer)
    };
};

module.exports = {
    name: "graded-group-set",
    displayName: "Graded group set (articles only)",
    widget: GradedGroupSet,
    traverseChildWidgets: traverseChildWidgets,
    // TODO(michaelpolyak): This widget should be available for articles only
    hidden: false,
    tracking: "all",
    isLintable: true
};

var styles = StyleSheet.create({
    top: {
        display: "flex",
        flexDirection: "row"
    },
    spacer: {
        flex: 1
    },

    title: {
        fontSize: 12,
        color: gray76,
        textTransform: "uppercase",
        marginBottom: 11,
        letterSpacing: 0.8
    },

    indicatorContainer: {
        display: "flex",
        flexDirection: "row"
    },

    indicator: {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: grayLight,
        marginLeft: 5,
        cursor: "pointer"
    },

    selectedIndicator: {
        backgroundColor: kaGreen
    },

    container: {
        borderTop: "1px solid " + gray76,
        borderBottom: "1px solid " + gray76,
        backgroundColor: tableBackgroundAccent,
        marginLeft: negativePhoneMargin,
        marginRight: negativePhoneMargin,
        paddingBottom: phoneMargin,
        paddingLeft: phoneMargin,
        paddingRight: phoneMargin,
        paddingTop: 10,
        width: "auto"
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/graded-group-set.jsx
 ** module id = 108
 ** module chunks = 0 1
 **/